import React from 'react';
import Emoji from 'react-emoji-render';

export interface IEmojiProps{
    text?: string
    className?: string
}

const Emoticons = (props: IEmojiProps): JSX.Element => (
    <Emoji text={props.text} className='emoticons'/>
);

export default Emoticons;
